import type { Video } from '@/types';

export const EXCLUSIVES_ROW_LIMIT = 12;

/**
 * The creator-videos endpoint has no exclusive filter yet (BACK-219), so the Home tab
 * filters the newest window it already fetched. Exclusives older than that window are
 * missed until the backend param lands.
 */
export function pickExclusiveVideos(
  videos: readonly Video[],
  excludeUuid?: string,
  limit = EXCLUSIVES_ROW_LIMIT
): Video[] {
  return videos
    .filter((v) => v.is_exclusive_content === true && v.uuid !== excludeUuid)
    .slice(0, limit);
}
